import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const productPackageApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/productPackage",
      params,
    }),
};
